import React from 'react';
import { useLocation } from 'react-router-dom';
import CustomBuildContent from '../features/userSettings/components/CustomBuildContent';
import ProcessTracker from '../features/processTracker/ProcessTracker';
import PromptInput from '../features/promptInput/PromptInput';

const PATH_TITLE = {
  '/workspace/custom-build':    'Custom Build',
  '/workspace/services':        'Service Management',
  '/workspace/ddlc':            'DDLC Pipeline',
  '/workspace/prompt-renderer': 'Prompt Renderer',
};

const WorkspacePage = () => {
  const { pathname } = useLocation();

  const renderContent = () => {
    if (pathname === '/workspace/services')        return <ProcessTracker activeSection="services" />;
    if (pathname === '/workspace/ddlc')            return <ProcessTracker activeSection="ddlc" />;
    if (pathname === '/workspace/prompt-renderer') return <PromptInput />;
    return <CustomBuildContent />;
  };

  return (
    <div className="h-full flex flex-col bg-gray-100">
      <div className="flex-none bg-gray-100 px-4 sm:px-6 shadow-sm z-20">
        <div className="pt-4 pb-3 border-b border-gray-300">
          <h1 className="text-2xl font-bold text-primary">{PATH_TITLE[pathname] || 'Custom Build'}</h1>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto bg-gray-50">
        {renderContent()}
      </div>
    </div>
  );
};

export default WorkspacePage;
